<template>
  <div>
    <div class="section-background">
      <v-row no-gutters align="center">
        <h3 class="section-name">Повідомлення</h3>
        <v-row no-gutters justify="end" align="center">
          <span class="filters-name">Статус:</span>
          <div style="width: 150px !important">
            <v-autocomplete
              v-model="statusFilter"
              :items="statusOptions"
              item-text="text"
              item-value="value"
              hide-no-data
              hide-selected
              class="status-filter"
              outlined
              dense
              hide-details
              style="margin-right: 20px"
            />
          </div>
          <span class="filters-name">Період:</span>
          <div style="width: 200px !important">
            <v-autocomplete
              v-model="periodFilter"
              :items="periodOptions"
              item-text="text"
              item-value="value"
              hide-no-data
              hide-selected
              class="status-filter"
              outlined
              dense
              hide-details
              style="margin-right: 20px"
            />
          </div>
        </v-row>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="messages"
        :loading="loading"
        hide-default-footer
        hide-default-header
        :items-per-page="100"
        background-color="red"
        no-data-text="Жодного повідомлення не було додано"
        loading-text="Завантаження..."
      >
        <template v-slot:header="{ props }">
          <th
            @click="
              head.sortable && head.sortable !== false
                ? setSortField(head.value)
                : ''
            "
            v-for="head in props.headers"
            :key="head.id"
            style="padding: 15px"
          >
            <v-row
              no-gutters
              align="center"
              :justify="head.align ? head.align : 'start'"
              ><output
                style="
                  color: #18181b;
                  font-family: Manrope;
                  font-size: 13px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 22px;
                  cursor: pointer;
                  user-select: none;
                "
                >{{ head.text }}
                <v-icon
                  v-if="head.sortable !== false"
                  size="25px"
                  :color="head.value == sortBy ? 'black' : ''"
                  >mdi-menu-swap</v-icon
                >
              </output>
            </v-row>
          </th>
        </template>
        <template v-slot:[`item.id`]="{ item, index }">
          <v-row no-gutters justify="center"></v-row>
          <span class="tableItem">{{ index + 1 }}</span>
        </template>
        <template v-slot:[`item.phone`]="{ item }">
          <div style="width: max-content">
            <a :href="`tel:${item?.phone}`" style="text-decoration: none">
              <span class="tableItem">{{
                item?.phone | VMask("+## ### ## ## ## ##")
              }}</span>
            </a>
          </div>
        </template>
        <template v-slot:[`item.user`]="{ item }">
          <span class="tableItem">
            {{ item?.user?.first_name }} {{ item?.user?.last_name }}</span
          >
        </template>
        <template v-slot:[`item.message`]="{ item }">
          <div
            style="
              width: 350px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            {{
              item.user_message.length > 100
                ? item.user_message.substring(0, 100) + "..."
                : item.user_message
            }}
          </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            @click="(showDetailMessageModal = true), (itemForDetail = item)"
            color="#E2E8F0"
            outlined
            style="text-transform: none; border-radius: 6px"
          >
            <span
              style="
                color: #1976d2 !important;
                color: #1976d2;
                font-size: 12px;
                font-style: normal;
                font-weight: 600;
                line-height: 18px;
              "
              >Деталі</span
            >
          </v-btn>
        </template>
      </v-data-table>
    </div>
    <!-- <v-row no-gutters justify="center">
      <v-pagination :length="5" v-model="page" color="#1976D2"></v-pagination>
    </v-row> -->
    <detail-message-modal
      v-if="showDetailMessageModal"
      :visible="showDetailMessageModal"
      :message="itemForDetail"
      :statusOptions="statusOptions.filter((status) => status.text !== 'Всі')"
      @close="showDetailMessageModal = false"
    />
  </div>
</template>

<script>
import feedbackService from "../../../requests/Admin/feedbackService";
import detailMessageModal from "./detailMessageModal.vue";
export default {
  components: {
    detailMessageModal,
  },
  data: () => ({
    loading: true,
    statusFilter: null,
    periodFilter: "week",
    statusOptions: [],
    periodOptions: [
      { text: "Останні 7 днів", value: "week" },
      { text: "Останні 14 днів", value: "two_week" },
      { text: "Останні 30 днів", value: "month" },
      { text: "Всі", value: "all" },
    ],
    page: 1,
    messages: [],
    headers: [
      { text: "Ім’я", value: "name", sortable: false, align: "start" },
      { text: "Email", value: "email", sortable: false, align: "start" },
      { text: "Телефон", value: "phone", sortable: false, align: "start" },
      {
        text: "Повідомлення",
        value: "message",
        sortable: false,
        align: "start",
      },
      { text: "Опції", value: "action", sortable: false, align: "start" },
    ],
    itemForDetail: null,
    showDetailMessageModal: false,
  }),
  mounted() {
    this.getFeedbackStatuses();
    this.getMessages();
  },
  methods: {
    async getMessages() {
      await feedbackService
        .getFeedbacks(this.statusFilter, this.setDates())
        .then((res) => {
          this.messages = res;
          this.loading = false;
        });
    },
    async getFeedbackStatuses() {
      await feedbackService.getFeedbackStatuses().then((res) => {
        this.statusOptions = res.statuses.map(
          (item) =>
            (item = {
              text: this.getStatusText(item),
              value: item,
            })
        );
        this.statusOptions.unshift({
          text: "Всі",
          value: null,
        });
      });
    },
    getStatusText(text) {
      switch (text) {
        case "pending":
          return "В очікуванні";
        case "in_progress":
          return "В процесі";
        case "done":
          return "Виконано";
        case "cancelled":
          return "Скасовано";
      }
    },
    setDates() {
      let endDate = new Date();
      let startDate = new Date();
      switch (this.periodFilter) {
        case "week":
          startDate.setDate(endDate.getDate() - 7);
          break;
        case "two_week":
          startDate.setDate(endDate.getDate() - 14);
          break;
        case "month":
          startDate.setDate(endDate.getDate() - 30);
          break;
        case "all":
          startDate = null;
          endDate = null;
          break;
      }
      if (!startDate || !endDate) return "";
      return `date_from=${startDate
        .toISOString()
        .substring(0, 10)} 00:00:00&date_to=${endDate
        .toISOString()
        .substring(0, 10)} 23:59:59`;
    },
  },
  watch: {
    statusFilter() {
      this.loading = true;
      this.getMessages();
    },
    periodFilter() {
      this.loading = true;
      this.getMessages();
    },
  },
};
</script>

<style scoped>
.filters-name {
  color: #18181b;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  margin-right: 10px;
}
</style>